import React from 'react';

const Step3Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-3">
        Se devi installare un solo condizionatore, in una unica stanza, dovrai acquistare un Monosplit.<br />
        Se devi installare più condizionatori su stanze che sono attigue, potrai scegliere anche impianti Multisplit.
        </div>
    );
}

export default Step3Infos;